export var fromPage;
(function (fromPage) {
    fromPage["EVENT_PAGE"] = "event";
    fromPage["FEATURES_PAGE"] = "features";
    fromPage["TIME_PAGE"] = "time";
    fromPage["FILECLUSTER_PAGE"] = "fileCluster";
    fromPage["TASK_PAGE"] = "task";
    fromPage["BIGDATA_PAGE"] = "bigData";
    fromPage["TEXT"] = "text";
})(fromPage || (fromPage = {}));
